import { useMemo } from "react"

import type { UsageType } from "@/utils/types"

export const UsageOptions: Array<{ value: UsageType; label: string }> = [
  { value: "bookmark", label: "Bookmark" },
  { value: "dialogue", label: "Dialogue" },
  { value: "summariser", label: "Summariser" },
]

export function ThemeUsageLabel({ usage }: { usage: string }) {
  const label = useMemo(() => UsageOptions.find((opt) => opt.value === usage)?.label ?? usage, [usage])
  return label
}
